module.exports = __webpack_public_path__ + "static/media/tier-2.3ecb7d56.jpg";